import { animateMotionValue } from './basler-components.es851.js';
import { isMotionValue } from './basler-components.es820.js';
import { motionValue } from './basler-components.es800.js';

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
    motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

export { animateSingleValue };
